export default function Banners() {
    return (
        <div className="about__img">
            <picture>
                <img className="w-100 " src="https://www.pride.ru/images/uploaded/banners/ce024eda1cc262c116ba92e15617f3eebeb331e8.jpeg" alt=""/>
            </picture>
        </div>
    );
}